import React, { memo } from 'react';
import classNames from 'classnames';
import { Impression } from '@benzinga/analytics';
import { sanitizeHTML } from '@benzinga/frontend-utils';
import styles from './KeyPoints.module.scss';

export interface KeyPointsProps {
  className?: string;
  data: string[];
  isPaywalled?: boolean;
  dynamicKeyPoint?: string;
  article?: {
    url: string | undefined;
    nodeId: number | undefined;
  };
  trackImpression?: boolean;
}

export const KeyPoints: React.FC<KeyPointsProps> = memo(
  ({ article, className = '', data, dynamicKeyPoint, isPaywalled }) => {
    return (
      <Impression
        campaign_id={`zinger-key-points-${article?.nodeId}`}
        tag={`zinger-key-points-${article?.nodeId}`}
        unit_type={`zinger-key-points-${article?.nodeId}`}
      >
        <div className={classNames(styles.container, 'key-points', className)}>
          <div className="key-points-header">Zinger Key Points</div>
          <ul>
            {Array.isArray(data) &&
              data.map((item, index) => (
                <li className={`bullet-point ${isPaywalled && index > 0 ? 'blur-sm' : ''}`} key={index}>
                  {item}
                </li>
              ))}
            {dynamicKeyPoint && (
              <li className="bullet-point bullhorn">
                <span className="bell-icon text-xs">
                  <BullhornIcon />
                </span>
                <span className="bullhorn-text" dangerouslySetInnerHTML={{ __html: sanitizeHTML(dynamicKeyPoint) }} />
              </li>
            )}
          </ul>
        </div>
      </Impression>
    );
  },
);

export const LightBlueKeyPoints: React.FC<React.PropsWithChildren<{ className?: string }>> = ({
  children,
  className,
}) => <div className={classNames(styles.lightBlueWrapper, 'key-points-wrapper', className)}>{children}</div>;

export const DarkKeyPoints: React.FC<React.PropsWithChildren<{ className?: string }>> = ({ children, className }) => (
  <div className={classNames(styles.darkWrapper, 'key-points-wrapper', className)}>{children}</div>
);

function BullhornIcon() {
  return (
    <svg fill="none" height="12" viewBox="0 0 16 14" width="14" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M11.834 1.533a.71.71 0 00-1.23-.486 6.707 6.707 0 01-4.892 2.12H3.334a2.501 2.501 0 00-2.5 2.5v.666a2.501 2.501 0 002.5 2.5h2.378c1.853 0 3.625.768 4.893 2.12a.71.71 0 001.229-.486V1.534zM14.668 5.5h-1a.5.5 0 000 1h1a.5.5 0 000-1zM12.793 8.667l.707.707a.501.501 0 00.707-.707l-.707-.708a.501.501 0 00-.707.708zM13.5 4.041l.707-.707a.501.501 0 00-.707-.707l-.707.707a.501.501 0 00.707.707z"
        fill="#3F83F8"
        fillRule="evenodd"
      ></path>
      <path
        clipRule="evenodd"
        d="M2.965 9.479l.45 2.722c.093.563.58.977 1.151.977h1.562a.832.832 0 00.746-1.206l-.392-.785a.17.17 0 01-.014-.034L6.063 9.51c-.117-.007-2.976-.017-3.098-.031z"
        fill="#3F83F8"
        fillRule="evenodd"
      ></path>
    </svg>
  );
}

export default KeyPoints;
